import { AmplitudeAnalytics } from "./amplitude-analytics";
import { NoopAnalytics } from "./analytics.interface";

function shouldBeDefined<T>(
  value: T | undefined,
  valueName: string = "value"
): T {
  if (value === undefined) {
    throw new Error(`${valueName} is undefined`)
  }

  return value
}


// export const analytics = new AmplitudeAnalytics(
//   shouldBeDefined(process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY) || ''
// );


export const analytics =
  process.env.NEXT_PUBLIC_APP_ENVIRONMENT === 'production'
    ? new AmplitudeAnalytics(
      shouldBeDefined(process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY)
    )
    : new NoopAnalytics();
